import { renderMarkdown } from "@/common/markdown/renderMarkdown";

export function parseWikiFrontmatter(raw) {
    const match = raw.match(/^---\n([\s\S]*?)\n---\n?([\s\S]*)$/);
    if (!match) return { meta: {}, body: raw };

    const meta = {};
    match[1].split("\n").forEach((line) => {
        const i = line.indexOf(":");
        if (i === -1) return;
        meta[line.slice(0, i).trim()] = line.slice(i + 1).trim();
    });
    if (meta.modes) {
        meta.modes = meta.modes.split(",").map((mode) => mode.trim());
    }
    if (meta.roles) {
        try {
            meta.roles = JSON.parse(meta.roles);
        } catch {
            meta.roles = {};
        }
    }

    return { meta, body: match[2] };
}

export function parseWikiSegments(body) {
    const roleBlock = /:::role\n([\s\S]*?)\n:::/g;
    const segments = [];
    let lastIndex = 0;
    let match;
    while ((match = roleBlock.exec(body))) {
        const before = body.slice(lastIndex, match.index);
        if (before.trim()) {
            segments.push({
                type: "text",
                html: renderMarkdown(before)
            });
        }
        segments.push({
            type: "role",
            html: renderMarkdown(match[1])
        });
        lastIndex = roleBlock.lastIndex;
    }
    const rest = body.slice(lastIndex);
    if (rest.trim()) {
        segments.push({ type: "text", html: renderMarkdown(rest) });
    }
    return segments;
}
